/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/*
* Display metadata popup window
*/
import React, { Component } from 'react';
import { TEXT_TYPES } from "../../../constants/APP_CONSTANTS";
import FileUploadDisplayComponent from '../../widgets/FileUploadDisplay/FileUploadDisplayComponent';
import AxiosClient from '../../../_helpers/http.helper';
import config from "../../../config";
import urlHelper from '../../../_helpers/url.format.helper';
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import { Link } from 'react-router-dom';

export default class ImportCCManagement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            file: "",
            formData: "",
            showPopup: false,
            percentage: 0,
            batchId: "",
            showBatchCompletePopup: false,
            batchStatus: "",
            failedMsg: "",
            showBatchStatus: "",
            disableImport: true,
            disableSelect: false
        };
        this.showPopup = this.showPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.cancelPopup = this.cancelPopup.bind(this);
        this.axiosRequest = this.axiosRequest.bind(this);
        this.closeBatchCompletePopup = this.closeBatchCompletePopup.bind(this);
        this.popupFileWindow = this.popupFileWindow.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    popupFileWindow() {
        document.getElementById("fileLoader").click();
    }

    handleChange(e) {
        if (e.target.files.length > 0) {
            const formData = new FormData();
            formData.append('file', e.target.files[0]);
            this.setState({ formData: formData, showBatchStatus: "", failedMsg: "", file: e.target.files[0].name, disableImport: false });
        }
    }

    showPopup() {
        this.setState({ showPopup: true, showBatchStatus: "", failedMsg: "", disableSelect: true, disableImport: true  });
    }

    closePopup() {
        this.setState({ showPopup: false, disableSelect: true });
    }

    cancelPopup() {
        this.setState({ showPopup: false, disableSelect: false, disableImport: false });
    }

    showBatchCompletePopup() {
        this.setState({ showBatchCompletePopup: true });
    }

    closeBatchCompletePopup() {
        if (this.coverLinkTimeout) {
            clearInterval(this.coverLinkTimeout);
        }
        this.setState({ percentage: 0, disableImport: true, showBatchStatus: this.state.batchStatus, showBatchCompletePopup: false });
    }

    changeUploadProgress() {
        this.setState({ percentage: 100 });
    }

    axiosRequest() {
        this.closePopup();
        let searchRoute = config.contentService.routes.uploadCoverTemplateDetails;
        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            searchRoute,
            {
                queryParams: {
                    metadataType: TEXT_TYPES.COVER_TEMPLATE_METADATA
                }
            }
        );
        this.coverLinkTimeout = setInterval(() => {
            if (this.state.percentage < 90) {
                this.setState({ percentage: this.state.percentage + 5 });
            }
        }, 2000);
        AxiosClient.post(url, this.state.formData, { "headers": { "content-type": "multipart/form-data" } })
            .then(response => {
                this.changeUploadProgress();
                setTimeout(() => this.showBatchCompletePopup(), 500);
                this.setState({ batchId: response.data, batchStatus: TEXT_TYPES.SUCCESS_MSG, disableSelect: false });
            })
            .catch(error => {
                console.log("Error");
                if(error.response){
                    this.changeUploadProgress();
                    setTimeout(() => this.setState({ percentage: 0 }), 500);
                    this.setState({ batchStatus: TEXT_TYPES.FAILED_MSG});
                    if (typeof error.response.data.message === 'object') {
                        this.setState({ failedMsg: " (" + (error.response.data.message)[Object.keys(error.response.data.message)[0]] + ")" });
                    }
                    else {
                        this.setState({ failedMsg: " (" + error.response.data.message + ")" });
                    }
                }
                else{
                    this.setState({ batchStatus: TEXT_TYPES.FAILED_MSG});
                }
                if (this.coverLinkTimeout) {
                    clearInterval(this.coverLinkTimeout);
                }
                this.setState({ disableImport: true, disableSelect: false, showBatchStatus: this.state.batchStatus });
                return error;
            });
    }

    render() {
        return (
            <div className="import-cc-management">
                <div>
                    <label className="pe-page-title--small">{TEXT_TYPES.UPLOAD_COVER_IMAGE_TEMPLATE_DETAILS}</label>
                    <hr />
                    <label>{TEXT_TYPES.SELECT_COVER_IMAGE_TEMPLATE_DETAILS_UPLOAD_NOTE}</label>
                </div>
                <div>
                    {this.state.file != ""
                        && <FileUploadDisplayComponent file={this.state.file} percentage={this.state.percentage} showBatchStatus={this.state.showBatchStatus} failedMsg={this.state.failedMsg}></FileUploadDisplayComponent>
                    }
                    <ModalDialog
                        title={TEXT_TYPES.UPLOAD_COVER_IMAGE_TEMPLATE_DETAILS_CONFIRMATION}
                        showModal={this.state.showPopup}
                        onCancel={this.cancelPopup}
                        onSuccess={this.axiosRequest}
                        successText="OK">
                        <div className="modal-body">
                            <p>
                                {TEXT_TYPES.UPLOAD_COVER_IMAGE_TEMPLATE_DETAILS_CONFIRMATION_MSG.replace("$file", this.state.file)}
                            </p>
                        </div>
                    </ModalDialog>
                    <ModalDialog
                        title={TEXT_TYPES.UPLOAD_SUMMARY}
                        showModal={this.state.showBatchCompletePopup}
                        onCancel={this.closeBatchCompletePopup}
                        onSuccess={this.closeBatchCompletePopup}
                        successText="OK">
                        <div className="modal-body">
                            <p>
                                <label>{TEXT_TYPES.UPLOAD_COVER_IMAGE_TEMPLATE_DETAILS_SUCCESS_MSG.replace("$file", this.state.file)} {this.state.batchId}.  <Link to="/cover-template-status"><b>{TEXT_TYPES.VIEW_STATUS_MSG}</b></Link></label>
                            </p>
                        </div>
                    </ModalDialog>
                </div>
                <br></br>
                <div className="pe-col-12 fileLoad">
                    <div className="buttons">
                        <input type="file" id="fileLoader" name="files" title="Load File" onClick={(event)=> { event.target.value = null; }} onChange={this.handleChange} />
                        <button type="file" name="files" className="pe-btn selectBtn " onClick={this.popupFileWindow} disabled={this.state.disableSelect}>Select</button>
                    </div>
                    <div className="buttons">
                        <button className="pe-btn pe-btn__primary" onClick={this.showPopup} disabled={this.state.disableImport}>Import</button>
                    </div>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/ImageIngestion/UploadCoverImageTemplateDetailsComponent.js